<template>
  <v-flex
    id="familyReaction"
    class="question"
  >
    <h2 class="header">
      {{ $t('gift_giving_report.menu.part_1.4') }}
    </h2>
    <ul class="questions-list">
      <li v-if="giftGivingReportQuestions.hasOwnProperty('family_response')">
        <p
          class="custom"
          :class="{ required: giftGivingReportQuestions.family_response.required }"
        >
          {{ giftGivingReportQuestions.family_response.label }}
        </p>
        <v-textarea
          v-model="familyReaction"
          v-validate="{
            ...regularLongText(giftGivingReportQuestions.family_response.required, FAMILY_REACTION_MAX_LENGTH)
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('familyReaction')"
          :data-vv-as="' '"
          :data-vv-name="'familyReaction'"
          :required="giftGivingReportQuestions.family_response.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import validationRules, { FIELD_LENGTH } from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'giftGivingReport/getGiftGivingReportState',
    mutationType: 'giftGivingReport/updateGiftGivingReportState'
});

export default {
    name: 'FamilyReaction',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules,
            FAMILY_REACTION_MAX_LENGTH: FIELD_LENGTH.MAX_LONG_FIELD_LENGTH
        };
    },
    computed: {
        ...mapFields(['familyReaction']),
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions'])
    }
};
</script>

<style scoped></style>
